var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_320_298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9375 0H14.0625C6.25 0 0 6.25 0 14.0625V23.4375V35.9375C0 43.75 6.25 50 14.0625 50H35.9375C43.75 50 50 43.75 50 35.9375V23.4375V14.0625C50 6.25 43.75 0 35.9375 0Z",
    fill: "#EF3561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 37.5C31.9036 37.5 37.5 31.9036 37.5 25C37.5 18.0964 31.9036 12.5 25 12.5C18.0964 12.5 12.5 18.0964 12.5 25C12.5 31.9036 18.0964 37.5 25 37.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0625 12.5C40.7884 12.5 42.1875 11.1009 42.1875 9.375C42.1875 7.64911 40.7884 6.25 39.0625 6.25C37.3366 6.25 35.9375 7.64911 35.9375 9.375C35.9375 11.1009 37.3366 12.5 39.0625 12.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_320_298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.5134a8cd5ea0bbc14ea7d04db270092f.svg";
export { ForwardRef as ReactComponent };